import { Route } from 'react-router-dom';
import { TracedRoutes } from '@comeon/error-reporter';
import { useSelector } from 'react-redux';
import { ROUTE_CASINO, ROUTE_LIVE_CASINO } from '~/components/router/constants.js';
import NavBar from '~/components/casino-shared/navbar/navbar-async.js';
import { selectCasinoMaintenanceEnabled } from '~/components/brand/ducks/selectors.js';
import NullLoader from '~/components/null-loader';

const RoutesNavbar = () => {
	const isCasinoMaintenanceEnabled = useSelector(selectCasinoMaintenanceEnabled);
	return (
		<TracedRoutes>
			<Route index />
			<Route path={`${ROUTE_LIVE_CASINO}/*`} element={<NavBar />} />
			{!isCasinoMaintenanceEnabled && <Route path={`${ROUTE_CASINO}/*`} element={<NavBar />} />}
			<Route path="*" element={<NullLoader />} />
		</TracedRoutes>
	);
};

export default RoutesNavbar;
